import $ from "jquery";
import * as ActionTypes from "./actionTypes";

const stylesheetHref = "highContrastTheme.css";
const stylesheetId = "high-contrast-theme";

export function toggleContrast() {
  return (dispatch, getstate) => {
    if (getstate().accessibility.isHighContrast) {
      window.localStorage.setItem("darkTheme", false);
      $(`#${stylesheetId}`).remove();
    } else {
      window.localStorage.setItem("darkTheme", true);
      $("head").append(
        `<link href='${stylesheetHref}' id='${stylesheetId}' rel='stylesheet' />`
      );
    }
    dispatch({ type: ActionTypes.TOGGLE_CONTRAST });
  };
}






// WEBPACK FOOTER //
// ./src/actions/accessibilityActions.js